<script setup></script>
<template>
	<div class="horizontal-scroll">
		<div class="horizontal-scroll__title title">let’s explore <span class="title-border">the game</span>&nbsp;</div>
		<div class="horizontal-scroll__title title">let’s explore <span class="title-border">the game</span>&nbsp;</div>
		<div class="horizontal-scroll__title title">let’s explore <span class="title-border">the game</span>&nbsp;</div>
		<div class="horizontal-scroll__title title">let’s explore <span class="title-border">the game</span></div>
	</div>
</template>
<style lang="scss" scoped>
.horizontal-scroll {
    display: flex;
    width: fit-content;
    animation: scroll 20s linear infinite;
    -webkit-transform-style: preserve-3d;
}

.horizontal-scroll__title {
    text-wrap: nowrap;
    white-space: nowrap;
    -webkit-backface-visibility: hidden;
}
@keyframes scroll {
    0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>
